module.exports = __webpack_public_path__ + "static/chronos-10067c22c18a184f0640a1dbcb0f15a4.png";